<ndt-add-prompt-view
   [callState]="callState | async"
   [form]="form"
   [onlyPromptTypeOption]="onlyPromptTypeOption"
   [excludedPromptTypes]="excludedPromptTypes"
   [includedPromptTypes]="includedPromptTypes"
   [promptIdIfUpdatingExistingPromptFile]="promptIdIfUpdatingExistingPromptFile"
   (saveAndAddAnother)="onCreate(true)"
   [creatingNewFromExtension]="creatingNewFromExtension"
   [includeReusableOption]="includeReusableOption"
   [includeAddAnother]="inlcudeAddAnother"
   [routeToNewPromptAfterSave]="routeToNewPromptAfterSave"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate(false)"
   (callInitiated)="onRecord($event)"
   [recordingPromptCallStatus]="recordingPromptCallStatus$ | async"
   (recordingPromptCallCancelled)="onCancelPromptRecordingCall()"
>
</ndt-add-prompt-view>
